// @flow
import * as React from 'react'
import styled, { css } from 'styled-components'
import { Link } from 'gatsby'

import colors from '../styles/colors'

const Button = ({
  label,
  link,
  color = 'default',
  width = '100%',
  icon,
  marginTop = false,
  marginLeft = false,
  small = false,
  children = null,
  altTag,
  srText,
  ariaLabel = null,
  imgAriaHidden = null,
  ...props
}) =>
  !link ? (
    <StyledButton
      $color={color}
      $width={width}
      $icon={icon}
      $left={marginLeft.toString()}
      small={small}
      aria-label={ariaLabel}
      {...props}
    >
      {label}
      {children}
      {srText && <Hidden>{srText}</Hidden>}

      {icon && <StyledImg src={icon} marginTop={marginTop} alt={altTag} aria-hidden={imgAriaHidden} />}
    </StyledButton>
  ) : (
    <StyledLink
      to={link}
      $color={color}
      $width={width}
      $icon={icon}
      $left={marginLeft.toString()}
      aria-label={ariaLabel}
      {...props}
    >
      {label}
      {srText && <Hidden>{srText}</Hidden>}
      {icon && <StyledImg src={icon} alt={altTag} aria-hidden={imgAriaHidden} />}
    </StyledLink>
  )

const buttonColors = {
  default: css`
    color: ${colors.white};
    background-color: ${colors.monza};
    &:hover {
      background-color: ${colors.dark_red};
    }
  `,
  white: css`
    color: ${colors.monza};
    background-color: ${colors.white};
    font-weight: 500;
  `,
  plain: css`
    color: ${colors.light_black};
    background-color: transparent;
    font-weight: 500;
    border: 1px solid transparent;
  `,
  grey: css`
    background-color: ${colors.blackOpacity};
    font-weight: 500;
    border: none;
  `,
}

const StyledImg = styled.img`
  height: 20px;
  position: absolute;
  margin-left: 10px;
  ${(props) => props.marginTop && `margin-top: -3px`};
`

const commonStyles = css`
  white-space: nowrap;
  color: ${colors.black};
  font-size: 14px;
  font-weight: 500;
  padding: ${(props) => (props.small ? '8px 15px' : '16px 30px')};
  ${(props) => props.$left === 'true' && `margin-left: 40px`};
  ${(props) => props.$icon && `padding-right: 55px`};
  ${(props) => props.postModal && `margin: 0 0 10px 10px`};
  text-decoration: none;
  box-shadow: none;
  background-color: ${colors.white};
  border: 1px solid ${colors.monza};
  border-radius: 4px;
  width: ${(props) => props.$width};
  opacity: ${(props) => (props.disabled ? 0.8 : 1)};
  transition: 0.3s background-color;
  height: auto;
`

const StyledButton = styled.button`
  ${commonStyles};
  ${(props) => buttonColors[props.$color]};
  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};

`

const StyledLink = styled(Link)`
  ${commonStyles};
  ${(props) => buttonColors[props.$color]};
  text-align: center;
`

const Hidden = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
`

export default Button
